var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-debug"},[(_vm.showRender)?_c('FormRender',{attrs:{"value":_vm.formModel,"formCode":_vm.codeData,"formJSON":_vm.formJSON,"formRules":_vm.formRules,"usedMap":_vm.usedMap,"publicSource":_vm.publicSource,"process":_vm.process,"readonly":_vm.readonly,"done":_vm.done}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }